// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2BCIS","footerGradient":"Footer_footerGradient__3sFA6","footerItem":"Footer_footerItem__mwO4N"};